<div *ngIf="IframeOpen" class="iframe-holder">
  <div class="iframe-container">
    <iframe #widgethost id="widgethost" class="bb-i-frame" [src]="iFrameURL | safeURL"></iframe>
  </div>
</div>
